import { Injectable } from '@angular/core';
import { HttpService } from 'services/http/http.service';
import { Observable } from 'rxjs';
import { CustomFields } from '../custom-fields.interface';
import { createFileUploadHeaders } from 'utils/helpers';
import { ShowIfHttpError } from '@certemy/common';
import { CUSTOM_FIELD_TYPES } from 'constants/constants';

@Injectable()
export class InstanceCustomFieldsService {
  constructor(private http: HttpService) {}

  @ShowIfHttpError('Cannot receive organizational custom fields.')
  getUserCustomFields(profileId: number): Observable<CustomFields.ItemInstance[]> {
    return this.http.get(`/profile/${profileId}/custom-fields`);
  }

  @ShowIfHttpError('An error occurred while saving attachment.')
  uploadAttachmentForCustomField(valueId: number, data: FormData) {
    return this.http.put(`/custom_field_value/${valueId}/attachments`, data, createFileUploadHeaders());
  }

  @ShowIfHttpError('An error occurred while deleting attachment.')
  removeAttachmentForCustomField(valueId: number, fileId: number) {
    return this.http.delete(`/custom_field_value/${valueId}/attachment/${fileId}`);
  }

  @ShowIfHttpError('Cannot update organizational custom fields.')
  updateUserCustomField(item: CustomFields.FieldInstance): Observable<CustomFields.FieldInstance> {
    if (item.type_id === CUSTOM_FIELD_TYPES.PHONE_NUMBER) {
      item.default_value = item.default_value ? item.default_value.replace(/\D+/g, '') : '';
      item.value = item.value ? item.value.replace(/\D+/g, '') : '';
    } else if ([CUSTOM_FIELD_TYPES.STRING, CUSTOM_FIELD_TYPES.TEXTAREA].includes(item.type_id)) {
      item.value = item.value ? item.value.trim() : item.value;
    }
    return this.http.put(`/custom-field-value/${item.value_id}`, item);
  }
}
